export default "__VITE_PUBLIC_ASSET__683cbe5e__"